import { ref } from 'vue';

let initialized = false;

export function useAppInit() {
    const isLoading = ref(false);
    const siteStore = useSiteStore();
    const categoryStore = useCategoryStore();
    const siteApi = useSite();
    const categoryApi = useCategory();

    async function initApp() {
        if (initialized) {
            return;
        }
        initialized = true;

        isLoading.value = true;
        try {
            // Attendre que window.env soit chargé
            await waitForWindowEnv();
            
            i18n.global.locale.value = getCurrentLocale();
            await getAndSetSite();
            await getTranslation();
            await getAndSetCategories();
        } catch (error) {
            console.error('Erreur d\'init de l\'app :', error);
        } finally {
            isLoading.value = false;
        }
    }

    // Fonction pour attendre que window.env soit chargé
    async function waitForWindowEnv(): Promise<void> {
        return new Promise((resolve) => {
            const checkEnv = () => {
                if (typeof window !== 'undefined' && window.env) {
                    console.log('✅ [waitForWindowEnv] window.env chargé:', window.env);
                    resolve();
                } else {
                    console.log('⏳ [waitForWindowEnv] Attente de window.env...');
                    setTimeout(checkEnv, 100);
                }
            };
            checkEnv();
        });
    }

    async function getAndSetSite() {
        console.log('🔍 [getAndSetSite] Début de getAndSetSite');
        console.log('🔍 [getAndSetSite] window.env:', window.env);
        console.log('🔍 [getAndSetSite] VITE_BACK_URL:', window.env?.VITE_BACK_URL);
        console.log('🔍 [getAndSetSite] window.location.href:', window.location.href);
        
        const { data, error } = await siteApi.getSiteInfos();
        console.log('🔍 [getAndSetSite] Réponse API:', { data: data.value, error: error.value });
        
        if (error.value) {
            console.error('❌ [getAndSetSite] Erreur API:', error.value);
            throw new Error('Site introuvable');
        }
        if (data.value) {
            console.log('✅ [getAndSetSite] Site trouvé:', data.value);
            siteStore.setSite(data.value);
            updateCSSVariables(siteStore);
            await siteStore.setConfiguration(siteStore.site.configurationUrl);
        }
    }

    async function getTranslation() {
        if (!siteStore.site?.translationUrl) {
            return;
        }
        const VITE_BACK_URL = window.env.VITE_BACK_URL;
        const translationUrl = `${VITE_BACK_URL}/downloadSvg?filename=${siteStore.site.translationUrl}`;
        await fetchAndMergeTranslations(translationUrl);
    }

    async function getAndSetCategories() {
        const { data, error } = await categoryApi.getProductsGroupByCategories();
        if (error.value) {
            throw new Error('Erreur de récupération des catégories');
        }
        if (data.value) {
            categoryStore.setCategories(data.value);
        }
    }

    return { initApp, isLoading };
}

function getCurrentLocale() {
    return navigator.language.startsWith('fr') ? 'fr' : 'en';
}
